const addCssPrefixTo = (cssClass: string): string => `CUSTOM_CSS_${cssClass.toUpperCase()}`;

export default addCssPrefixTo;
